import { t } from "@/i18n-js/instance";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";
import { MAXIMUM_PAYWALL_PRICES } from "../constants";
import { usePricingTabContext } from "./hooks/usePricingTabContext";

export interface AddPriceButtonProps {
  variant: "primary" | "secondary" | "circle";
}

export const AddPriceButton = ({ variant }: AddPriceButtonProps) => {
  const { showAddPriceModal, getActivePrices } = usePricingTabContext();

  const textColor = variant === "primary" ? "text-secondary" : "text-primary";
  const pricesCreatedCounter = getActivePrices().length;
  const isDisabled = pricesCreatedCounter >= MAXIMUM_PAYWALL_PRICES;

  return (
    <Button
      type="button"
      variant={variant}
      onClick={showAddPriceModal}
      className="whitespace-nowrap"
      disabled={isDisabled}
      large
    >
      <Typography.LabelSm weight="semibold" color={textColor}>
        {t("settings.paywalls.modal.tabs.pricing.actions.add_price")}
      </Typography.LabelSm>
    </Button>
  );
};
